var map = {
	"./AssessmentReport.svg": 267,
	"./Daily.svg": 268,
	"./EnrolledPatientReport.svg": 269,
	"./Failed.svg": 77,
	"./Ghana.svg": 270,
	"./HF.svg": 271,
	"./Info-blue.svg": 166,
	"./Info-green.svg": 165,
	"./Kenya.svg": 272,
	"./MOH.svg": 273,
	"./PatientDuplicateReport.svg": 274,
	"./PatientStatusReport.svg": 275,
	"./Pending.svg": 167,
	"./Permanent.svg": 276,
	"./Presc.svg": 277,
	"./ScreenedReport.svg": 278,
	"./Sierra Leone.svg": 279,
	"./Spice.svg": 280,
	"./SpiceEngage.svg": 281,
	"./Tanzania.svg": 282,
	"./UserPerformance.svg": 283,
	"./app-logo.svg": 161,
	"./arrow-right-small.svg": 284,
	"./assignQuickSightUser.svg": 168,
	"./avatar-o.svg": 285,
	"./bin.svg": 169,
	"./caret-down-grey.svg": 162,
	"./caret-down-white.svg": 286,
	"./checkbox-disabled.svg": 170,
	"./checkbox-empty.svg": 141,
	"./checkbox.svg": 142,
	"./close.svg": 171,
	"./download.svg": 106,
	"./dropdown.svg": 172,
	"./edit.svg": 107,
	"./hf1.svg": 287,
	"./hf2.svg": 288,
	"./hf3.svg": 289,
	"./hf4.svg": 290,
	"./hf7.svg": 291,
	"./hidePass.svg": 292,
	"./home.svg": 293,
	"./info-grey.svg": 294,
	"./info-orange.svg": 164,
	"./insights.svg": 295,
	"./no-icon.svg": 199,
	"./plus.svg": 173,
	"./power-switch.svg": 163,
	"./quickSightUser.svg": 174,
	"./reports.svg": 296,
	"./reset.svg": 175,
	"./search.svg": 176,
	"./send-disabled.svg": 177,
	"./send.svg": 178,
	"./showPass.svg": 179,
	"./success-blue.svg": 108,
	"./success-green.svg": 180,
	"./tick.svg": 297,
	"./user-role-assigned.svg": 181,
	"./user-role-not-assigned.svg": 182,
	"./warning.svg": 183
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 157;